export default {
  header: {
    search: 'Пошук',
    bag: 'Кошик',
		logoImageTitle: 'Магазин Sitelle'
  },

  footer: {
    menu1: {
      title: 'Підтримка клієнтів'
    },
    menu2: {
      title: 'Юридична інформація'
    }
  },

  sidebar: {
    toTop: 'До початку'
  },

  links: {
    learnAbout: 'Дізнайся більше',
    checkout: 'Оформити замовлення',
    allShoes: 'Все взуття',
    goToHomepage: 'На головну сторінку',
    continueDeliveryAddress: 'Продовжити оформлення замовлення',
    reviewYourOrder: 'Переглянути замовлення',
    orderPay: 'РОЗМІСТИТИ ЗАМОВЛЕННЯ',
    back: 'Назад',
    next: 'Наступний крок'
  },

  mainMenu: {
    item1: 'Все взуття',
    item2: 'Про бренд',
    item3: 'Магазини',
    item4: 'Контакти',
    submenu: {
      item1: 'Лодочки',
      item2: 'Босоніжки',
      item3: 'Кеди',
      item4: 'Elegant look',
      item5: 'Summer time',
      item6: 'Soft & comfortable'
    }
  },

  footerMenu: {
    menu1: {
      item1: 'Безпека платежів',
      item2: 'Політика доставки',
      item3: 'Політика повернень та відшкодувань',
			item4: 'Карта сайту'
    },
    menu2: {
      item1: 'Правила та умови',
      item2: 'Політика конфіденційності',
      item3: 'Політика про файли cookie'
    }
  },

  mobileMenu: {
    close: 'закрити'
  },

  search: {
    close: 'Закрити',
    loading: 'Іде завантаження ...',
    input: 'Які туфлі ви бажаєте знайти?'
  },

  filters: {
    title: 'фільтр:',
    list: {
      size: 'Розмір',
      color: 'Колір',
      heel: 'Підбори',
      ocassion: 'Де носити',
      sale: 'Знижки'
    },
    notFound: 'Фільтрів не знайдено'
  },

  sorting: {
    title: 'сортувати за:',
    list: {
      latest: 'Нові',
      lowPrice: 'Низька ціна',
      highPrice: 'Висока ціна',
      popular: 'Популярні'
    }
  },

  breadcrumbs: {
    home: 'SITELLE',
		allShoes: 'Все взуття',
		sitemap: 'Карта сайту',
  },

  products: {
    sale: 'Знижки',
    notFound: 'Товар не знайдено',
    share: 'Поділитися',
    latest: {
      title: 'Тобі може сподобатись'
    },
    color: 'Колір',
    size: 'Розмір',
    heelHeight: 'Підбори',
    materials: 'Матерiали',
    occasion: 'Де носити',
    origin: 'Виробництво',
    addToBag: 'Додати до корзини',
    addedToBag: 'Товар додано до корзини',
		noPrice: 'Product has no price',
		delivery: 'Доставка',
		and: ' та ',
		return: 'повернення',
		free: ' в Україні безкоштовні.',
    links: {
      payment: 'Оплата',
      shipping: 'Політика доставки',
      return: 'Політика повернень та відшкодувань'
    },
    selectSize: 'Оберіть будь ласка розмір'
  },

  forms: {
    firstName: "Ім'я",
    lastName: 'Прізвище',
    fullName: "Ім'я та Прізвище",
    email: 'Email',
    country: 'Країна',
    address: 'Вулиця та номер будинку',
    appt: '№ кв.',
    city: 'Місто',
    phone: 'Номер телефону',
    state: 'Область',
    postcode: 'Індекс',
    enterPromocode: 'Введіть код тут',
    selectDelivery: 'Оберіть спосіб доставки',
    selectPayment: 'Оберіть спосіб оплати',
    enterAddress: 'Вкажіть адресу або відділення Нова Пошта',
		errors: {
			firstName: 'Ім\'я - обов\'язкове',
      lastName: 'Прізвище - обов\'язкове',
      fullName: "Ім'я та прізвище - обов'язкові",
			email: 'Email - обов\'язковий',
			country: 'Країна - обов\'язкова',
			address: 'Вулиця та номер будинку - обов\'язкові',
			city: 'Місто - обов\'язкове',
			phone: 'Номер телефону має містити тільки цифри',
      postcode: 'Індекс має містити тільки цифри',
      required: 'Поле обов\'язкове'
		}
  },

  tables: {
    name: "Ім'я:",
    email: 'Email:',
    deliveryAddress: 'Адреса доставки:',
    phone: 'Телефон:',
    deliveryMethod: 'Спосіб доставки:',
    paymentMethod: 'Спосіб оплати:',
    deliveryMethod1: 'Доставка за адресою',
    deliveryMethod2: 'Доставка у відділення Нова Пошта',
    paymentMethod1: 'Оплата карткою на сайті',
    paymentMethod2: 'Оплата при отриманні товару'
  },

  errors: {
    terms: 'Вам потрібно погодитися з правилами сайту'
  },

  pages: {
    catalog: {
			title: 'Все взуття',
			productImageTitle: 'Італійське взуття SITELLE: ',
			productImageNumber: ' — фото ',
    },
    error: {
      title: 'Сторінка не знайдена.',
      descr:
        'Сторінка не знайдена. Можливо, ви ввели невірну адресу або сторінка була видалена.'
    },
    cart: {
      title: 'Кошик',
      product: {
        size: 'Розмір:',
        remove: 'Видалити з кошика'
      },
      info:
        'Промо, знижки та оплати будуть додані під час оформлення замовлення',
      empty: {
        title: 'Кошик порожній',
        descr: 'Подивитися все взуття'
      },
      loading: 'Іде завантаження ...'
    },
    checkout: {
      steps: {
        title: 'крок',
        of: 'з 4'
      },
      step1: {
        title: "Ваше ім'я"
      },
      step2: {
        title: 'Доставка та оплата'
      },
      step3: {
        title: 'Перевірити замовлення'
      },
      order: {
        summary: 'Ваше замовлення',
        size: 'розмір:',
        subtotal: 'Сума',
        shipping: 'Shipping',
        promotionalCode: 'Промокод',
        applyVoucher: 'Застосувати промокод',
        deleteVoucher: 'Видалити промокод',
        total: 'Всього'
      },
      privacy: {
        text1: 'Я погоджуюсь з',
        text2: 'Політикою конфіденційності',
        text3: 'та',
        text4: 'Правилами',
        text5: 'сайту'
      },
      coupone: {
        notExist: {
          text1: 'Купон',
          text2: 'не знайдений!'
        }
      },
      info:
        "There is a possibility that the payer's bank will charge an additional fee."
    },
    contacts: {
      title: 'Контакти',
      callUs: 'Зателефонувати',
      writeUs: 'Написати',
      followUs: 'Підписатися у соц мережах'
		},
		aboutUs: {
			imageAlt: 'Італійська преміальна якість',
			imageAltNumber: 'Італійська преміальна якість — фото ',
			imageBenefitsAlt: 'Цінності Sitelle',
		},
    success: {
      heading: 'Дякуємо!<br>Сподіваємося, що ви отримаєте задоволення від вашого взуття',
      subheading: 'Номер замовлення:',
      text: 'Наш менеджер надішле деталі замовлення на: '
    },
		sitemap: {
			heading: 'Карта сайту'
		}
  },

  modals: {
    orderFitting: {
      title: 'Замовити безкоштовну примірку',
      text1: "Привозимо кур'єром у Києві до 8 пар",
      text2: 'Відправляємо Новою Поштою до 3 пар',
      order: 'Замовити',
      thanks: 'Дякуємо за Ваше замовлення. Ми Вам подзвонимо'
    }
  },

  meta: {
    catalog: {
      title: 'Каталог якісного італійського взуття: лодочки, босоніжки і кеди в SITELLE',
      description: 'Преміальна якість і кращі матеріали італійського взуття в SITELLE Store ❤ → Купити оригінальні туфлі, босоніжки і кеди з Італії. Безкоштовна доставка і примірка в Україні! Каталог якісного італійського взуття в інтернет-магазині SITELLE.'
    },
    category: {
			h1: 'Жіночі ',
			title1: 'Преміальні жіночі туфлі з Італії в SITELLE. ',
			title2: ' з Італії в SITELLE',
			description1: 'Купити модні жіночі ',
			description2: ' з Італії в SITELLE Store ❤ → стильні, яскраві і модні якісні ',
			description3: ' в інтернет магазині SITELLE! Безкоштовна доставка і примірка в Україні! Кращі оригінальні туфлі з Італії!'
    },
    product: {
      title1: 'Купити ',
			description1: 'Купити модні жіночі ',
			description2: ' з Італії в SITELLE Store ❤ → стильні, яскраві і модні якісні туфлі в інтернет магазині SITELLE! Замовити ',
			description3: ' з безкоштовною доставкою і приміркою в Україні!',
    },
    cart: {
      title: 'Кошик - Sitelle store',
      description: 'Bag description'
    },
    checkout: {
      title: 'Оформити замовлення - Sitelle store',
      description: 'Checkout description'
    },
    contacts: {
      title: 'Контактна інформація про SITELLE в Україні',
      description: 'Контактна інформація про SITELLE в Україні. Інформація та телефони для зв\'язку.'
    },
    success: {
      title: 'Success - Sitelle store',
      description: 'Success description'
    },
  }
}
